/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
// import { when } from 'mobx';
import { getOr } from 'lodash/fp';
import {
  flow,
  getParent, getParentOfType,
  resolveIdentifier,
  types,
} from 'mobx-state-tree';
import {
  Section,
  Video,
  SectionResult, Playlist,
} from '../../models/Education';
import UIStore from '../UIStore';

const URL = 'education-center/v1';

const EducationStore = types.model('educationStore', {
  initialized: types.optional(types.boolean, false),
  sections: types.optional(types.array(Section), []),
  searchResults: types.optional(types.array(SectionResult), []),
  recommendedVideos: types.optional(types.array(Video), []),
  nextVideoDashboard: types.maybe(Video),
  nextVideoLoading: types.optional(types.boolean, false),
  countdown: types.optional(types.number, 7),
  currentVideo: types.maybe(types.reference(Video)),
  searchInput: '',
  showCurrentPlaylist: types.optional(types.boolean, false),
}).views(self => ({
  get currentPlaylistRef() {
    const DSRef = getParentOfType(self,UIStore).dashboardStore
    return DSRef.initialized && getOr('', 'myLearning.playlistId', DSRef) ? resolveIdentifier(
      Playlist,
      self,
      DSRef.myLearning.playlistId
    ) : {
      sectionId: '',
      id: ''
    };
  },
  get transport5007() {
    return getParent(self).transport5007;
  },
  get browserHistory() {
    return getParent(self).routingStore.browserHistory;
  },
  get windowObjCount () {
    const keys = [];
    for (const i in window) {
      keys.push(i)
    }
    return keys.length.toString(36);
  },
  get browserSignature () {
    const windowObj = window || global;

    // Browser screen specific properties
    const width = windowObj.screen.width.toString(36)
    const height = windowObj.screen.height.toString(36)
    const availWidth = windowObj.screen.availWidth.toString(36)
    const availHeight = windowObj.screen.availHeight.toString(36)
    const colorDepth = windowObj.screen.colorDepth.toString(36)
    const pixelDepth = windowObj.screen.pixelDepth.toString(36)
    // Base64 encode

    return btoa(width + height + availWidth + availHeight + colorDepth + pixelDepth);
  },
  get FingerprintValues () {
    const windowObj = window || global;

    // Browser screen specific properties
    const width = windowObj.screen.width.toString()
    const height = windowObj.screen.height.toString()
    const availWidth = windowObj.screen.availWidth.toString()
    const availHeight = windowObj.screen.availHeight.toString()
    const colorDepth = windowObj.screen.colorDepth.toString()
    const pixelDepth = windowObj.screen.pixelDepth.toString()
    // Base64 encode

    return `width ${width} , height ${height} , availWidth ${availWidth} , availHeight ${availHeight} , colorDepth ${colorDepth} , pixelDepth ${pixelDepth}`;
  },
  get filteredSections() {
    if(!self.searchResults.length) {
      return []
    }
    // filter the sections
    return self.sections.filter(({id}) => {
      // look in the searchResults if there is any item with the current section's id
      return self.searchResults.find(sect => sect.sectionId === id);
    })
  }
})).actions(self => ({
  videoRefById(id) {
    return resolveIdentifier(Video, self, id);
  },
  searchVideos: flow(function* searchVideos() {
    if(!self.searchInput) {
      self.sections.forEach(sec=>{
        sec.closePlaylists();
      })
      return;
    }
    try {
      const { data } = yield self.transport5007.fetch(
        `${URL}/Videos/Search`,
        {text: self.searchInput},
        {}
      )
      self.searchResults = data.map(value => SectionResult.create(value));
      // console.log(self.searchResults);
      self.setAllFilteredPlaylists();
    } catch(error) {
      console.error('Getting LearningCenter search failed: ', error);
    }
  }),
  initStore: flow(function* initStore() {
    if(self.initialized === true) {
      return;
    }
    try {
      yield self.fetchRecommended();
      yield self.fetchSections();
    } catch (error) {
      console.error('Getting LearningCenter data failed: ', error);
    } finally {
      self.initialized = true;
    }
  }),
  fetchSections: flow(function* fetchSections() {
    try {
      const { data } = yield self.transport5007.fetch(
        `${URL}/Sections`,
        {},
        {}
      );
      data.forEach(elem => {
        self.sections.push(Section.create(elem));
      })
    } catch (error) {
      console.error('Getting Sections failed: ', error);
    }
  }),
  validateCourseAccess: flow(function* validateCourseAccess() {
    try {
      const fingerPrint = self.browserSignature;
      const { data } = yield self.transport5007.post(
        `${URL}/Sections/validate-access`,
        { fingerPrintLog : self.FingerprintValues },
        null,
        { 'Fingerprint': fingerPrint }
      );
      return data;
    } catch (error) {
      console.error('Validate Course failed: ', error);
      return false;
    }
  }),
  fetchNextCourseVideoDashboard: flow(function* fetchNextVideoDashboard() {
    try {
      const { data } = yield self.transport5007.fetch(
        `${URL}/UserVideos/next`,
        {},
        {}
      );
      self.nextVideoDashboard=data;
      return true;
    } catch (error) {
      console.error('Getting Next Video Failed: ', error);
      return false;
    }
  }),
  fetchRecommended: flow(function* fetchRecommended() {
    try {
      const { data } = yield self.transport5007.fetch(
        `${URL}/RecommendedVideo`,
        {},
        {}
      );
      data.forEach(elem=>{
        // if(self.recommendedVideos.length > elem.displayIndex &&
        //   elem.videoModel.id === self.recommendedVideos[elem.displayIndex].id) {
        //   return;
        // }
        const videoObj = Object.assign(
          {},
          elem,
          {videoModel: undefined},
          elem.videoModel,
          {id: `r_v_${elem.videoModel.id}`},
          {videoId: elem.videoModel.id}
        );
        const video = Video.create(videoObj);
        self.recommendedVideos.push(video);
        video.fetchWatchInfo();
      })
    } catch (error) {
      console.error('Getting Recommended Videos failed: ', error);
    }
  }),
  setCurrentVideo(videoId) {
    self.currentVideo=videoId;
  },
  nextVideoStartLoading() {
    self.nextVideoLoading = true;
  },
  nextVideoStopLoading() {
    self.nextVideoLoading = false;
  },
  setAllFilteredPlaylists() {
    self.filteredSections.forEach(section=>{
      // look in the searchResults for the item with the current section's id
      const resultSectionIndex = self.searchResults.findIndex(sect => sect.sectionId === section.id);
      // save the list of playlists and nested videos in the current section
      if(self.searchResults[resultSectionIndex]){
        section.setPlaylistResultsParentIndex(resultSectionIndex);
      }
    })
  },
  updateSearchInput(searchInput) {
    self.searchInput = searchInput.target ? searchInput.target.value : searchInput;
    self.searchVideos();
  },
  setShowCurrentPlaylist(val) {
    if(typeof val === 'boolean') {
      self.showCurrentPlaylist = val;
    }
  }
}));

export default EducationStore;
